import NoInternetMessage from './NoInternetMessage';
export default NoInternetMessage;
